import { Constants } from './companyConstants'
import { Company } from '../../../model/company.model'

export function setCompanies(companies: Company[]) {
  return {
    type: Constants.SET_COMPANIES,
    payload: companies,
  } as const
}

export function addCompany(company: Company) {
  return {
    type: Constants.ADD_COMPANY,
    payload: company,
  } as const
}

export function updateCompany(company: Company) {
  return {
    type: Constants.UPDATE_COMPANY,
    payload: company,
  } as const
}

export function removeCompany(companyId: number) {
  return {
    type: Constants.REMOVE_COMPANY,
    payload: companyId,
  } as const
}